<template>
  <div>
    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>
        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              placeholder="Search here..."
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <my-button
        type="orange"
        @click="addModal = true"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; BUAT KURIKULUM BARU
      </my-button>
    </div>
    <br />
    <br />

    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleEdit(row.item.id)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Edit
        </b-button>
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-danger"
          @click="handleDelete(row.item)"
        >
          <fa-icon icon="trash-alt" class="my-icon" />&nbsp;Delete
        </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Buat Kurikulum Baru</h3>
        <br />
        <label>Nama Kurikulum</label>
        <br />
        <b-form-input
          placeholder="Nama .. "
          v-model="inputData.name"
        ></b-form-input>
        <br />
        <label>Deskripsi</label>
        <b-form-input
          placeholder="Deskripsi Singkat .. "
          v-model="inputData.description"
        ></b-form-input>
        <br />
        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="addCurriculum"
          >
            SIMPAN
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

    <b-modal
      v-model="editModal"
      id="editModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="editModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Edit Kurikulum</h3>
        <br />
        <label>Nama Kurikulum</label>
        <br />
        <b-form-input
          placeholder="Nama .. "
          v-model="editData.name"
        ></b-form-input>
        <br />
        <label>Deskripsi</label>
        <b-form-input
          placeholder="Deskripsi Singkat .. "
          v-model="editData.description"
        ></b-form-input>
        <br />
        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="editCurriculum"
          >
            SIMPAN
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      isBusy: false,
      items: [],
      fields: [
        {
          key: "no",
          label: "No"
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "description",
          label: "Deskripsi",
          sortable: true
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      addModal: false,
      editModal: false,
      inputData: {
        name: "",
        description: ""
      },
      editData: {
        name: "",
        description: "",
        id: 0
      },
      showLoading: false
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },

  mounted() {
    this.totalRows = this.items.length;
    this.curriculumList();
  },

  methods: {
    ...mapActions({
      getCurriculumList: types.GET_CURRICULUM_LIST,
      setNewCurriculum: types.SET_NEW_CURRICULUM,
      getCurriculumDetail: types.GET_CURRICULUM_DETAIL,
      updateCurriculum: types.UPDATE_CURRICULUM,
      deleteCurriculum: types.DELETE_CURRICULUM
    }),
    curriculumList() {
      this.isBusy = true;
      this.getCurriculumList()
        .then(response => {
          var res = response;
          this.items = [];
          for (var i = 0; i < res.length; i++) {
            var dataItem = {
              no: i + 1,
              id: res[i].id,
              name: res[i].name,
              description: res[i].description
            };
            this.items.push(dataItem);
          }
          this.totalRows = res.length;
          this.isBusy = false;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    handleDelete(index) {
      this.$bvModal.msgBoxConfirm('Delete this data?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            this.deleteCurriculum({id:index.id})
              .then(response => {
                this.curriculumList(response);
                this.showMessageBox("Deleted", "Success", "success");
              })
              .catch(error => {
                this.showMessageBox(error, "Failed", "success");
              });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "success");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleEdit(no) {
      this.editModal = true;
      this.getCurriculumDetail(no)
        .then(response => {
          var res = response;
          this.editData.name = res.name;
          this.editData.description = res.description;
          this.editData.id = res.id;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    closeModal() {
      this.$bvModal.hide("modal-confirm");
    },
    addCurriculum() {
      this.showLoading = true;
      this.setNewCurriculum(this.inputData)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.addModal = false;
          this.showLoading = false;
          this.inputData = {
            name: "",
            description: ""
          };
          this.curriculumList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    editCurriculum() {
      this.showLoading = true;
      this.updateCurriculum(this.editData)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.editModal = false;
          this.showLoading = false;
          this.curriculumList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
        .msgBoxOk(message, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: variant,
          centered: true
        })
        .then(value => {
          this.temp = value;
        })
        .catch(err => {
          this.temp = err;
        });
    }
  }
};
</script>

<style>
.search-wrapper {
  width: 100%;
  max-width: 222px;
}

.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>